module.exports = __webpack_public_path__ + "static/media/account white.f2e8b7e9.svg";